import React from "react";
import "./organisationCard.css";
import { Organisation } from "../../features/organisation/organisationTypes";
import { ColumnFlexBox, RowFlexBox } from "../common/FlexBoxes";
import { CaptionCondensed, Icon, Label, ParagraphSmall, Tooltip } from "@tal-gel/components-v2";
import { useTheme } from "@emotion/react";
interface propsFromComponent {
  item: Organisation;
}

type Props = propsFromComponent;

const OrganisationServiceTypeInfo: React.FC<Props> = ({ item }) => {
  const theme = useTheme();

  return (
    <ColumnFlexBox style={{ gap: "8px", paddingBottom: "16px" }}>
      <Label className="service-label">Service Type</Label>
      <ColumnFlexBox style={{ gap: "4px" }}>
        {item.serviceTypes.map(organisationServiceType => (
          <ColumnFlexBox key={organisationServiceType.id}>
            <RowFlexBox style={{ justifyContent: "space-between", gap: "16px" }}>
              <RowFlexBox style={{ gap: "8px", alignItems: "flex-start" }}>
                <Icon name="Check" fill={theme.tokens.global.themeColorIconDefault} width="18" style={{ paddingTop: 1 }} />
                <ParagraphSmall>{organisationServiceType.serviceType.externalName}</ParagraphSmall>
              </RowFlexBox>
              <Tooltip
                content={
                  <ColumnFlexBox style={{ gap: "16px" }}>
                    <CaptionCondensed appearance="inverse">{organisationServiceType.description}</CaptionCondensed>
                    <RowFlexBox style={{ alignItems: "center", gap: "8px" }}>
                      <Icon
                        name={"LocationPin"}
                        style={{ paddingTop: 1 }}
                        fill={theme.tokens.global.themeColorIconDefault}
                        width={"18px"}
                      />
                      <CaptionCondensed appearance="inverse">
                        {organisationServiceType.states
                          .map(state => state.internalName)
                          .join(", ")
                          .toString()}
                      </CaptionCondensed>
                    </RowFlexBox>
                    <ColumnFlexBox
                      style={{
                        flexDirection: "row",
                        alignItems: "center",
                        gap: "8px",
                        display: organisationServiceType.cost ? "flex" : "none",
                      }}
                    >
                      <Icon
                        name={"CurrencyDollarCircle"}
                        style={{ paddingTop: 1 }}
                        fill={theme.tokens.global.themeColorIconDefault}
                        width={"18px"}
                      />
                      <CaptionCondensed appearance="inverse">{organisationServiceType.cost.externalName}</CaptionCondensed>
                    </ColumnFlexBox>
                  </ColumnFlexBox>
                }
                placement="right"
                variant="arrow"
              >
                <Icon name="InfoCircle" fill={theme.tokens.global.themeColorIconDefault} width={18} style={{ cursor: "pointer" }} />
              </Tooltip>
            </RowFlexBox>
          </ColumnFlexBox>
        ))}
      </ColumnFlexBox>
    </ColumnFlexBox>
  );
};

export default OrganisationServiceTypeInfo;
